import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
import { deduplicateSlots } from './deduplicate-slots';
export const getAvailabilitySlots = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ serviceId, selectedDate, timeZone })=>{
        const fromLocalDate = getLocalDateTimeStartOfDay(selectedDate);
        const toLocalDate = getLocalDateTimeEndOfDay(selectedDate);
        const availabilityEntries = (await queryAvailability({
            httpClient: _httpClient,
            errorHandler,
            request: {
                query: {
                    filter: {
                        serviceId: [
                            serviceId
                        ],
                        startDate: fromLocalDate,
                        endDate: toLocalDate,
                        bookable: true
                    }
                },
                timezone: timeZone,
                allowProxyToAvailability: true
            }
        }))?.availabilityEntries;
        return deduplicateSlots(availabilityEntries);
    };
};

//# sourceMappingURL=get-availability-slots.js.map